/* eslint @typescript-eslint/no-explicit-any: 0 */
import i18n from 'i18next';
export function createTranslationLink(key, defaultParams = {}) {
    return (params = {}) => i18n.t(key, {
        ...defaultParams,
        ...params,
    });
}
